import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';
import { groupItemMixin, jsonGroupItemMixin } from '../mixin/index.js';
import categoryMixin from '../mixin/category';
import V3GameDifficulty from '../components/v3-game-difficulty.vue';
import GroupLegend from '../components/group-legend.vue';
import ResetGameConfig from '../components/reset-game-config.vue';
import AddJsonCategoryConfig from './add-json-category-config.vue';
import RemoveJsonCategoryConfig from './remove-json-category-config.vue';
import StarButton from '../components/star-button.vue';
import { categoryConfig, presetConfigCategoryResourceType } from '@/store/creative/common/category';
import ResetResource from '@/views/creative/components/reset-resource.vue';

export default {
  mixins: [groupItemMixin, jsonGroupItemMixin, categoryMixin],

  components: {
    ResetResource: ResetResource,
    V3GameDifficulty: V3GameDifficulty,
    GroupLegend: GroupLegend,
    ResetGameConfig: ResetGameConfig,
    AddJsonCategoryConfig: AddJsonCategoryConfig,
    RemoveJsonCategoryConfig: RemoveJsonCategoryConfig,
    StarButton: StarButton
  },

  data: function data() {
    return {};
  },


  computed: _extends({}, mapState({
    gameDifficulty: function gameDifficulty(state) {
      return state.creative.template.gameDifficulty.toLowerCase();
    },
    gameConfigResource: function gameConfigResource(state) {
      return state.creative.template.gameConfigResource || null;
    },
    previewGroupConfig: function previewGroupConfig(state) {
      return state.creative.template.previewGroupConfig;
    },
    currentTab: function currentTab(state) {
      return state.creative.template.currentTab;
    },
    playConfig: function playConfig(state) {
      return state.creative.template.templateConfig.play_config;
    },
    originalJson: function originalJson(state) {
      return state.creative.template.originalJson;
    }
  }), {
    gameDifficultyList: function gameDifficultyList() {
      return _.get(this.gameConfigResource, 'gameDifficultyList') || [];
    },
    defaultGameDifficulty: function defaultGameDifficulty() {
      return (this.gameDifficultyList.find(function (item) {
        return item.is_default === true;
      }) || {}).data;
    },
    currentCategoryGameConfig: function currentCategoryGameConfig() {
      // gameConfigResource 的属性下的配置
      if (this.gameConfigResource && _.get(this.gameConfigResource, this.category.prefix)) {
        return _.get(this.gameConfigResource, this.category.prefix).map(function (item) {
          return _extends({}, item, {
            isDefault: false
          });
        });
      }

      // gameConfigResource.gameDifficultyList 的默认难度下的配置
      if (this.defaultGameDifficulty && _.get(this.defaultGameDifficulty, this.category.prefix)) {
        return _.get(this.defaultGameDifficulty, this.category.prefix);
      }

      return null;
    },


    // 当前预览组合的配置
    previewGroupGameConfig: function previewGroupGameConfig() {
      return _.get(this.previewGroupConfig, 'game_config');
    },
    clsName: function clsName() {
      var clsName = 'game-difficulty';
      if (Array.isArray(this.currentCategoryGameConfig)) {
        clsName += ' private-game-difficulty';
      } else {
        clsName += ' common-game-difficulty';
      }
      return clsName;
    },
    isPresetConfig: function isPresetConfig() {
      return this.category.resource_type === presetConfigCategoryResourceType;
    },
    currentCategoryPresetConfig: function currentCategoryPresetConfig() {
      if (this.isPresetConfig) {
        var presetConfig = this.templateConfig.json_config.presetConfig;
        return presetConfig[this.category.prefix];
      }
      return null;
    }
  }),

  methods: _extends({}, mapMutations({
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    updateCurrentResource: 'creative/template/updateCurrentResource',
    openEditResourceDialog: 'creative/template/openEditResourceDialog',
    addValidator: 'creative/template/addValidator',
    updateTargetGameConfigResource: 'creative/template/updateTargetGameConfigResource',
    updateGameDifficultyInGameConfigResource: 'creative/template/updateGameDifficultyInGameConfigResource'
  }), mapActions({
    updateTargetCategory: 'creative/template/updateTargetCategory',
    saveTemplate: 'creative/template/saveTemplate'
  }), {
    handleAddValidator: function handleAddValidator(validate) {
      this.$store.commit('creative/template/addValidator', validate);
    },


    /**
     * @param {{conf: {}, key: string}} param0
     */
    updateGameConfigValue: function updateGameConfigValue(_ref) {
      var conf = _ref.conf,
          index = _ref.index,
          key = _ref.key;

      // 非玩法 tab 内的玩法
      if (this.currentTab !== categoryConfig.gamePlay.id) {
        this.updateTargetGameConfigResource({
          key: key,
          value: _extends({}, conf)
        });
      } else {
        // 玩法 tab 内的玩法（非 dco 和非多组合制作）
        // dco 与多组合制作会在玩法 tab 内展示难度模式
        // 而非 dco 和非多组合制作不展示难度，但是数据层面上都是讲这些玩法抽象为难度模式，只有一种难度，且一级类目被拍平放在分类下
        this.updateGameDifficultyInGameConfigResource({
          key: key,
          value: _extends({}, conf),
          index: 0
        });
      }
    },
    handleReset: function handleReset() {
      if (this.originalJson && this.originalJson.presetConfig && this.originalJson.presetConfig[this.category.prefix] && this.originalJson.presetConfig[this.category.prefix].value) {
        console.log('当前配置默认选项', this.originalJson.presetConfig[this.category.prefix].value);
        this.templateConfig.json_config.presetConfig[this.category.prefix].value = this.originalJson.presetConfig[this.category.prefix].value;
      }
    },

    // 切换预设配置就触发保存
    updatePresetConfigValue: function updatePresetConfigValue() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.saveTemplate();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
};